import { render, staticRenderFns } from "./ModalBedHistory.vue?vue&type=template&id=5eeb9939&"
import script from "./ModalBedHistory.vue?vue&type=script&lang=js&"
export * from "./ModalBedHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports